<template>
  <div class="main">
    <div class="top">
      <el-tabs v-model="activeName">
        <el-tab-pane label="服务器信息" name="first"></el-tab-pane>
        <el-tab-pane label="基本信息" name="second"></el-tab-pane>
      </el-tabs>
    </div>
    <div class="content">
      <sysServer v-if="activeName == 'first'" ref="sysServer" />
      <sysBasic v-else-if="activeName == 'second'" ref="sysBasic" />
    </div>
  </div>
</template>

<script>
import sysServer from "./sysServer.vue";
import sysBasic from "./sysBasic.vue";

export default {
  name: "SystemSet",
  components: { sysServer, sysBasic },
  data() {
    return {
      activeName: "first"
    };
  }
};
</script>

<style lang="scss" scoped>
.main {
  width: 100%;
  height: 100%;
  .top {
    width: 100%;
    height: 56px;
    border-bottom: 1px solid #e5e8f1;
    display: flex;
    flex-direction: row;
    align-items: center;
    /deep/.el-tabs__nav-scroll {
      padding-left: var(--big-space) !important;
    }
    /deep/.el-tabs__header {
      margin-bottom: 5px !important;
    }
    /deep/.el-tabs__nav-wrap::after {
      height: 0 !important;
      background-color: none !important;
    }
  }
  .content {
    width: 100%;
    height: calc(100% - 56px);
    padding: var(--middle-space) var(--big-space);
  }
}
</style>
